
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Jyotilingadarshantourpackage() {



    const cardData =
    {
        keyword: '12 Jyotirlinga Darshan Tour Package from Pune',
        heading: 'Amruta Travels: 12 Jyotirlinga Darshan Tour Package from Pune',
        headingDescription: 'Amruta Travels offers 12 Jyotirlinga Darshan Tour Package from Pune, providing a comprehensive and spiritually enriching journey to the twelve sacred Jyotirlinga shrines across India. This meticulously planned pilgrimage covers revered temples such as Somnath, Mallikarjuna, Mahakaleshwar, Omkareshwar, Kedarnath, Bhimashankar, Kashi Vishwanath, Trimbakeshwar, Vaidyanath, Nageshwar, Rameshwar, and Grishneshwar. Our well-maintained fleet, including 17-seater, 32-seater, and 50-seater buses, ensures a comfortable and safe journey for all devotees. With experienced drivers, knowledgeable tour guides, affordable pricing, and 24/7 support, Amruta Travels makes your 12 Jyotirlinga Darshan from Pune a seamless and memorable spiritual experience. Book your pilgrimage with us today and embark on a journey of devotion and discovery!',


        top: '12 Jyotirlinga Darshan Tour with Amruta Travels',
"topPlaces": [
  {
    "title": "Somnath Jyotirlinga – Gujarat",
    "description": "Located in Prabhas Patan near Veraval in Gujarat, Somnath is considered the first of the 12 Jyotirlingas. The temple stands on the shores of the Arabian Sea and has been reconstructed several times due to invasions."
  },
  {
    "title": "Mallikarjuna Jyotirlinga – Andhra Pradesh",
    "description": "Situated in Srisailam on the banks of the Krishna River, this temple is nestled in the Nallamala hills. It is a combination of Jyotirlinga and Shakti Peetha, making it highly sacred."
  },
  {
    "title": "Mahakaleshwar Jyotirlinga – Madhya Pradesh",
    "description": "Located in Ujjain, this Jyotirlinga is one of the most important and is the only south-facing lingam. The Bhasma Aarti (ash ritual) at the temple is especially famous."
  },
  {
    "title": "Omkareshwar Jyotirlinga – Madhya Pradesh",
    "description": "Situated on the Mandhata Island in the Narmada River, the temple is shaped like the sacred Om symbol. It is one of the two Jyotirlingas in Madhya Pradesh."
  },
  {
    "title": "Kedarnath Jyotirlinga – Uttarakhand",
    "description": "Located in the Himalayas at an altitude of 3,583 meters, Kedarnath is accessible only during certain months due to snow. It's one of the most remote and spiritually powerful Jyotirlingas."
  },
  {
    "title": "Bhimashankar Jyotirlinga – Maharashtra",
    "description": "Located in the Sahyadri hills near Pune, this temple is surrounded by dense forests. It's believed to be the place where Lord Shiva destroyed the demon Tripurasura."
  },
  {
    "title": "Kashi Vishwanath Jyotirlinga – Uttar Pradesh",
    "description": "Located in the spiritual city of Varanasi, this temple is one of the most famous Jyotirlingas and holds great significance in Hindu belief as it is said to grant moksha (liberation)."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga – Maharashtra",
    "description": "Located near Nashik, this temple lies at the source of the Godavari River. It features a unique lingam with three faces representing Brahma, Vishnu, and Shiva."
  },
  {
    "title": "Vaidyanath Jyotirlinga – Jharkhand",
    "description": "Also known as Baba Baidyanath, this temple in Deoghar is associated with the legend of Ravana offering his ten heads to Shiva. It's a prominent pilgrimage site during the Shravana month."
  },
  {
    "title": "Nageshwar Jyotirlinga – Gujarat",
    "description": "Located near Dwarka, this temple is dedicated to Lord Shiva as the Lord of Serpents. It is believed to protect devotees from all poisons and negativity."
  },
  {
    "title": "Rameshwar Jyotirlinga – Tamil Nadu",
    "description": "Located on Rameswaram Island, this temple is closely linked with the Ramayana and Lord Rama. It is known for its magnificent corridors and sacred water tanks."
  },
  {
    "title": "Grishneshwar Jyotirlinga – Maharashtra",
    "description": "Located near the Ellora Caves in Aurangabad, this is the twelfth and final Jyotirlinga. The temple displays classic South Indian architecture and is the smallest among all Jyotirlingas."
  }
],



  "services": [
    {
      "name": "Pune to Rameshwaram Darshan Bus Hire on Rent",
      "description": "Amruta Travels offers comfortable bus rentals from Pune to Rameshwaram for Jyotirlinga Darshan. Our AC and Non-AC buses are perfect for long religious journeys, with spacious seating and experienced drivers ensuring a safe and spiritual travel experience."
    },
    {
      "name": "Pune to Trimbakeshwar Bus Hire On Rent",
      "description": "Travel to the sacred Trimbakeshwar Jyotirlinga from Pune with Amruta Travels. Our bus rental services include well-maintained vehicles ideal for group pilgrimages, ensuring timely service and a peaceful journey."
    },
    {
      "name": "Pune to Vaijnath Jyotirlinga Darshan Bus Hire",
      "description": "Book a spiritual journey from Pune to Vaijnath Jyotirlinga with Amruta Travels. Our fleet includes various seating capacities with comfortable interiors and skilled drivers to ensure a smooth darshan trip."
    },
    {
      "name": "Pune to Grishneshwar Bus Hire On Rent",
      "description": "Amruta Travels provides reliable bus hire services from Pune to Grishneshwar Temple near Aurangabad. Ideal for religious groups and families, we ensure a smooth travel experience with AC and Non-AC options."
    },
    {
      "name": "Pune to Somnath Jyotirlinga Gujarat Bus On Rent",
      "description": "Experience the divine with our Pune to Somnath Jyotirlinga bus rental service. Amruta Travels offers long-distance religious travel with comfortable buses, perfect for extended pilgrimage tours across Gujarat."
    },
    {
      "name": "Pune to Mallikarjuna Jyotirlinga Darshan Bus On Rent",
      "description": "Plan your pilgrimage from Pune to Mallikarjuna Jyotirlinga with Amruta Travels. Our buses are equipped for long routes, ensuring comfort and spiritual focus throughout your journey to Andhra Pradesh."
    },
    {
      "name": "Pune to Mahakaleshwar Ujjain Bus On Rent",
      "description": "Amruta Travels offers bus rentals from Pune to Mahakaleshwar Jyotirlinga in Ujjain. Enjoy a stress-free pilgrimage with our professional service and well-maintained buses suitable for groups of all sizes."
    },
    {
      "name": "Pune to Omkareshwar Bus on Rent",
      "description": "Visit the revered Omkareshwar temple from Pune with Amruta Travels. We provide both short and extended tour packages in AC and Non-AC buses for a convenient and spiritual experience."
    },
    {
      "name": "Pune to Bhimashankar Jyotirlinga Bus Hire on Rent",
      "description": "Amruta Travels offers daily and custom group bus rentals to Bhimashankar Jyotirlinga from Pune. Our services are ideal for one-day pilgrimages with safe and reliable travel options."
    },
    {
      "name": "Pune to Kashi Vishwanath Temple Bus Hire on Rent",
      "description": "Travel from Pune to the holy Kashi Vishwanath Temple in Varanasi with our long-route bus rental services. Amruta Travels ensures a devotional experience with clean, comfortable buses and dedicated staff."
    },
    {
      "name": "Pune to Kedarnath Bus Hire on Rent",
      "description": "Embark on a divine journey from Pune to Kedarnath with Amruta Travels. Our buses are well-equipped for hilly terrain and long routes, making them ideal for religious groups heading to the Himalayas."
    },
    {
      "name": "Pune to Nageshwar Jyotirlinga Bus Hire on Rent",
      "description": "Visit the sacred Nageshwar Jyotirlinga in Gujarat with Amruta Travels’ reliable bus hire service from Pune. We ensure smooth, safe travel with various seating capacities suitable for large groups."
    }
  ],
  "tableData": [
    ["Pune to Rameshwaram Darshan Bus Hire on Rent", "Pune to Trimbakeshwar Bus Hire On Rent"],
    ["Pune to Vaijnath Jyotirlinga Darshan Bus Hire", "Pune to Grishneshwar Bus Hire On Rent"],
    ["Pune to Somnath Jyotirlinga Gujarat Bus On Rent", "Pune to Mallikarjuna Jyotirlinga Darshan Bus On Rent"],
    ["Pune to Mahakaleshwar Ujjain Bus On Rent", "Pune to Omkareshwar Bus on Rent"],
    ["Pune to Bhimashankar Jyotirlinga Bus Hire on Rent", "Pune to Kashi Vishwanath Temple Bus Hire on Rent"],
    ["Pune to Kedarnath Bus Hire on Rent", "Pune to Nageshwar Jyotirlinga Bus Hire on Rent"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Exclusive 12 Jyotirlinga Darshan Tour from Pune",
    "WhyChoosedescription": "Embark on a spiritual journey with Amruta Travels' 12 Jyotirlinga Darshan Tour Package from Pune. This well-curated package covers all the significant Jyotirlinga temples across India, offering a comfortable and hassle-free pilgrimage experience. Our experienced drivers and well-maintained vehicles ensure that your journey is smooth and enriching."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Travel for Long Journeys",
    "WhyChoosedescription": "Our fleet includes 32, 35, 40, 45, and 50-seater buses equipped with modern amenities like air-conditioning, ample legroom, and comfortable seating. Whether it's a short journey or a multi-day trip, you can relax and enjoy the scenic routes while traveling to each Jyotirlinga temple."
  },
  {
    "WhyChooseheading": "Comprehensive Itinerary for a Spiritual Experience",
    "WhyChoosedescription": "The 12 Jyotirlinga Darshan Tour Package from Pune is designed to offer a seamless travel experience. We plan every detail of your pilgrimage, from temple visits to accommodations, ensuring a stress-free and spiritually fulfilling journey. The package covers major Jyotirlingas such as Somnath, Mallikarjuna, Mahakaleshwar, Kashi Vishwanath, and others."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our drivers are well-trained and have expertise in long-distance travel. With their knowledge of the routes to the 12 Jyotirlingas, you can trust that your journey will be safe, timely, and enjoyable. We ensure that you reach each destination with comfort and ease."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Costs",
    "WhyChoosedescription": "We provide transparent pricing for the 12 Jyotirlinga Darshan Tour Package, offering great value for your money. The package covers transportation, accommodation, and sightseeing at each temple, with no hidden fees. You can focus on your spiritual journey without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Hygienic, Clean, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our buses are regularly cleaned and maintained to high standards, ensuring cleanliness and comfort during your long-distance journey. With comfortable seating, large windows, and air-conditioning, we ensure that your pilgrimage is as comfortable as possible."
  },
  {
    "WhyChooseheading": "Customizable Tour Options for Your Convenience",
    "WhyChoosedescription": "Our 12 Jyotirlinga Darshan Tour Package is flexible and can be customized to fit your preferences. If you wish to modify the itinerary or add special requests, we are happy to accommodate your needs, ensuring that your pilgrimage experience is personal and meaningful."
  },
  {
    "WhyChooseheading": "Easy Booking and Dedicated Support",
    "WhyChoosedescription": "Booking your 12 Jyotirlinga Darshan Tour is simple with Amruta Travels. You can reserve your package online, over the phone, or in person. Our customer support team is available to assist with any questions, provide detailed information about the tour, and ensure all your needs are met before and during the journey."
  }
]













    }

const faqData = [
  {
    question: 'What is included in the 12 Jyotirlinga Darshan tour package from Pune?',
    answer: 'Our 12 Jyotirlinga Darshan tour package includes transportation, accommodation, meals, and guided tours to all the 12 Jyotirlinga temples. The package is customizable based on your preferences and travel dates.',
  },
  {
    question: 'How long does the 12 Jyotirlinga Darshan tour take?',
    answer: 'The 12 Jyotirlinga Darshan tour typically lasts 10 to 12 days, depending on the itinerary and stops. We ensure a smooth journey with plenty of time for darshan at each temple and comfortable travel arrangements.',
  },
  {
    question: 'How can I book the 12 Jyotirlinga Darshan tour from Pune?',
    answer: 'Booking the 12 Jyotirlinga Darshan tour is easy. You can contact us via phone, email, or online to book your tour. Our team will assist you in selecting the right dates and package details.',
  },
  {
    question: 'What is the cost of the 12 Jyotirlinga Darshan tour from Pune?',
    answer: 'The cost of the 12 Jyotirlinga Darshan tour depends on the number of people in your group, accommodation preferences, and travel dates. Please contact us for a detailed quote based on your specific requirements.',
  },
  {
    question: 'What transportation options are available for the 12 Jyotirlinga Darshan tour?',
    answer: 'We provide comfortable and spacious buses (32-seater, 35-seater, 40-seater, etc.) for the 12 Jyotirlinga Darshan tour. The buses are equipped with AC and other amenities for a pleasant travel experience.',
  },
  {
    question: 'Are meals included in the 12 Jyotirlinga Darshan tour package?',
    answer: 'Yes, our 12 Jyotirlinga Darshan tour package includes meals. We provide breakfast, lunch, and dinner at select locations, ensuring that you have a comfortable and enjoyable journey.',
  },
  {
    question: 'Is the tour guided?',
    answer: 'Yes, we provide experienced and knowledgeable guides to ensure a smooth and informative experience during your darshan at each of the 12 Jyotirlinga temples.',
  },
  {
    question: 'What are the benefits of booking a 12 Jyotirlinga Darshan tour with Amruta Travels?',
    answer: 'Booking with Amruta Travels ensures a hassle-free experience. We provide well-maintained buses, experienced drivers, professional guides, and customer-focused services to make your 12 Jyotirlinga Darshan tour memorable.',
  },
  {
    question: 'Do you provide customized 12 Jyotirlinga Darshan tour packages?',
    answer: 'Yes, we offer customized packages based on your preferences, including specific dates, accommodation types, and special requests. Let us know your requirements, and we’ll tailor the tour accordingly.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sunil Sharma',
    role: 'Traveler, Pune',
    text: 'I booked the 12 Jyotirlinga Darshan tour with Amruta Travels. The entire experience was amazing – comfortable buses, well-planned itinerary, and knowledgeable guides. The trip was spiritually enriching and well-organized. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rekha Deshpande',
    role: 'Pilgrim, Pune',
    text: 'We took the 12 Jyotirlinga Darshan tour with Amruta Travels and it was an unforgettable experience. The buses were comfortable, and the services were top-notch. The team was very professional and made the trip smooth and enjoyable. A must-try for anyone looking to visit all the Jyotirlingas.',
    rating: 5,
  },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "12 Jyotirlinga Darshan Tour Package from Pune",
  "image": "https://bushireinpune.com/assets/images/jyotirlinga-darshan-tour-package.jpg",
  "description": "Book a comprehensive 12 Jyotirlinga Darshan tour package from Pune. Travel in comfort to revered Jyotirlinga temples including Rameshwaram, Trimbakeshwar, Vaijnath, Somnath, and more. Enjoy hassle-free bus hire services with experienced drivers and affordable pricing for all temple visits.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5299",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/12-jyotirlinga-darshan-tour-package-from-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | 12 Jyotirlinga Darshan Tour Package from Pune | Temples Darshan & Bus Hire</title>
  <meta 
    name="description" 
    content="Book a 12 Jyotirlinga Darshan tour package from Pune to visit revered temples like Rameshwaram, Somnath, Trimbakeshwar, Omkareshwar, and more. Comfortable bus hire with experienced drivers for a spiritual journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Jyotilingadarshantourpackage;